<app-spinner></app-spinner>
<main class="app container">
    <div class="d-flex flex-column">
        <div class="d-flex align-items-center justify-content-end brand">
            <img style="margin: 0px auto" src="/assets/img/login/logo.svg" alt="webtest logo" />
        </div>
        <div class="d-flex flex-column align-items-center">
            <h1 class="login-header text-center">Update your password</h1>
            
        </div>
        <form ngNativeValidate class="p-4" [formGroup]="resetForm" (ngSubmit)="updatePassword()">
            <div class="" *ngIf="isError" style="width:fit-content; margin:0px auto">
                <em class="text-danger">{{alert}}</em>
            </div>
            <div *ngIf="resetForm.get('password').touched && !resetForm.get('password').valid"
                style="width:fit-content; margin:0px auto">
                <em class="text-danger">Password must contain minimum of eight characters</em>
            </div>
            <div class="form-group mb-3" style="width:fit-content; margin:0px auto">
                <label for="oldpassword" style="color: #092056; font-weight: 600;">Old Password</label>
                <div class="input-group">
                    <input id="oldpassword" type="password" class="form-control" placeholder="Old Password"
                        formControlName="oldpassword" required>
                </div>
                <label for="password" style="color: #092056; font-weight: 600;">New Password</label>
                <div class="input-group">
                    <input id="password" type="password" class="form-control" placeholder="New Password"
                        formControlName="password" required>
                </div>
                <label class="mt-2" for="password" style="color: #092056; font-weight: 600;">Confirm Password</label>
                <div class="input-group mt-0">
                    <input id="password2" type="password" class="form-control" placeholder="Confirm Password"
                        formControlName="confirmPassword" required>
                </div>
                <div *ngIf="passwordMatchError">
                    <em class="text-danger">Password does not match</em>
                </div>
            </div>
            <div class="d-flex flex-column">
                <button type="submit" class="d-flex justify-content-center align-items-center btn login-btn px-4"
                    [disabled]="!resetForm.valid">
                    <span style=" width:fit-content ; margin: 0px auto">Save</span>
                </button>
            </div>
        </form>
    </div>
</main>